import { Text } from '@wegroup/design-system';
import React from 'react';
import styled from 'styled-components';

// Components
import CheckMark from '../../../../../../common/src/components/CheckMark';
import IllustrationIconSelector from '../../../../../../common/src/components/IllustrationIconSelector';

interface Props {
  icon: string;
  title: string;
  description?: string;
  value?: boolean;
  onSelected: () => void;
}

const SingleSelectDetailedInput: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  title,
  description,
  value,
  onSelected,
}) => {
  return (
    <Wrapper
      onClick={onSelected}
      checked={value}
      data-test-id="ProdFac_SingleSelectDetailedInput"
    >
      <IconWrapper data-test-id="ProdFac_SingleSelectDetailedInput_Icon">
        {value && <StyledIconCheckmark />}
        <IllustrationIconSelector type={icon} active={value} />
      </IconWrapper>
      <Text
        textAlign="center"
        textStyle="largeBodyBold"
        data-test-id="ProdFac_SingleSelectDetailedInput_Label"
      >
        {title}
      </Text>
      {description && (
        <Text
          color="text.gray"
          textAlign="center"
          textStyle="smallBody"
          data-test-id="ProdFac_SingleSelectDetailedInput_Description"
        >
          {description}
        </Text>
      )}
    </Wrapper>
  );
};

const StyledIconCheckmark = styled(CheckMark)`
  position: absolute;
  top: -1.6rem;
  right: -1.6rem;
`;

const IconWrapper = styled.div`
  height: 7.2rem;
  padding-bottom: 1.6rem;

  > svg {
    width: 100%;
    height: 100%;
  }
`;

const Wrapper = styled.div<{ checked?: boolean }>`
  position: relative;
  max-width: 18rem;
  max-height: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ checked }) => (checked ? 'calc(2.4rem - 2px)' : '2.4rem')};

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
    0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 6px;

  background: #fff;
  transition: background-color 0.2s;
  &:hover {
    background: #fafafa;
  }

  cursor: pointer;
  border: ${({ checked, theme }) =>
    checked ? `2px solid ${theme.primary[500]}` : 'none'};
`;

export default SingleSelectDetailedInput;
